/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Button } from "react-bootstrap";

import routes from "routes.js";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

function Header(setIsCollapsed, isCollapsed) {
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down('md'));
  var admin = localStorage.getItem("username");
  const location = useLocation();
  
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
    <Navbar 
      style={{
        background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
        boxShadow: '0 8px 32px rgba(72, 219, 251, 0.1)',
        borderBottom: '2px solid #48dbfb',
        padding: '5px 0',
        minHeight: 'auto'
      }} 
      expand="lg"
    >
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <Button
            variant="dark"
            className="d-lg-none btn-fill d-flex justify-content-center align-items-center"
            style={{width:'10px',backgroundColor:'#48dbfb', padding: '4px' }}
            onClick={mobileSidebarToggle}
          >
            <i className="fas fa-ellipsis-v"></i>
          </Button>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav mr-auto" navbar>
            <div
              style={{
                fontSize: "22px",
                fontWeight: "800",
                color: '#fff'
              }}
            >
              Welcome back,
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "22px",
                  color: "#48dbfb",
                  fontWeight: "800",
                  textShadow: '0 0 10px rgba(72, 219, 251, 0.5)'
                }}
              >
                {admin}!
              </span>
            </div>
          </Nav>
        </Navbar.Collapse>

        {/* CamSecAI Pro Badge - Compact but Visible */}
        <div 
          style={{ 
            display: "flex", 
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
            gap: "3px"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              background: 'linear-gradient(135deg, rgba(72, 219, 251, 0.25) 0%, rgba(72, 219, 251, 0.1) 100%)',
              border: '2px solid #48dbfb',
              borderRadius: "10px",
              padding: "8px 14px",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 6px 20px rgba(72, 219, 251, 0.15)',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              minWidth: '260px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(72, 219, 251, 0.25)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(72, 219, 251, 0.15)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <SecurityIcon 
              sx={{ 
                color: '#48dbfb', 
                fontSize: '20px',
                filter: 'drop-shadow(0 0 10px rgba(72, 219, 251, 0.8))'
              }} 
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
              <div 
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#fff",
                  letterSpacing: '0.5px',
                  lineHeight: '1.1'
                }}
              >
                SECURED & VERIFIED BY
              </div>
              <div 
                style={{
                  fontSize: "13px",
                  fontWeight: "700",
                  background: 'linear-gradient(135deg, #48dbfb 0%, #00d4ff 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  letterSpacing: '0.8px',
                  lineHeight: '1.1'
                }}
              >
                CamSecAI ProMINI
              </div>
            </div>
            <VerifiedUserIcon 
              sx={{ 
                color: '#48dbfb', 
                fontSize: '18px',
                marginLeft: 'auto',
                filter: 'drop-shadow(0 0 8px rgba(72, 219, 251, 0.8))'
              }} 
            />
          </div>

          {/* Status Indicator */}

        </div>
      </Container>
    </Navbar>

    <style>{`
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
          box-shadow: 0 0 8px #48dbfb;
        }
        50% {
          opacity: 0.5;
          box-shadow: 0 0 16px #48dbfb;
        }
      }
    `}</style>
    </>
  );
}

export default Header;
